import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

// Logger utility that only logs in development
const isDevelopment = process.env.NODE_ENV === 'development';
const logger = {
  log: (...args) => isDevelopment && console.log(...args),
  error: (...args) => isDevelopment && console.error(...args)
};

// Reject empty strings, missing values, and obviously-broken/test URLs.
// Accept either absolute http(s) URLs or same-origin root-relative paths
// (e.g. /logo.png served from /app/frontend/public).
const isValidUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  if (!/^(https?:\/\/|\/)/i.test(url)) return false;
  if (/example\.com|placeholder|localhost/i.test(url)) return false;
  return true;
};

const STATIC_BRAND_KEYS = [
  'main_logo',
  'favicon',
  'hero_image',
  'about_image',
  'default_entity_image',
  'login_background',
  'dashboard_hero',
];

const sanitize = (data) => {
  const out = {};
  // Static brand fields
  STATIC_BRAND_KEYS.forEach((k) => {
    out[k] = isValidUrl(data?.[k]) ? data[k] : null;
  });
  // ANY map_pin_* field — pass through dynamically so per-entity-type pins
  // (map_pin_campgrounds_resorts, map_pin_concessionaire, etc.) reach the map.
  Object.entries(data || {}).forEach(([k, v]) => {
    if (k.startsWith('map_pin_')) {
      out[k] = isValidUrl(v) ? v : null;
    }
  });
  return out;
};

export const useThemeSettings = () => {
  const [themeSettings, setThemeSettings] = useState(() => sanitize({}));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchThemeSettings = async () => {
      try {
        const response = await axios.get(`${API}/theme-settings`);
        const cleaned = sanitize(response.data || {});
        setThemeSettings(cleaned);
        logger.log('Theme settings loaded — pins:',
          Object.fromEntries(
            Object.entries(cleaned).filter(([k]) => k.startsWith('map_pin_'))
          )
        );
      } catch (error) {
        logger.error('Error fetching theme settings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchThemeSettings();
  }, []);

  return { themeSettings, loading };
};
